<template>
  <div class="section" id="liveScheduleRegistration">
    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <h1 class="subtitle">配信予定登録</h1>

        <b-field label="次回配信開始時間を選択してください">
          <b-datetimepicker
            locale="ja-JP"
            v-model="startAt"
            placeholder="カレンダーから選択してください"
          >
            <template #left>
              <b-button
                label="Now"
                type="is-primary"
                icon-left="clock"
                @click="startAt = new Date()"
              />
            </template>

            <template #right>
              <b-button
                label="Clear"
                type="is-danger"
                icon-left="close"
                outlined
                @click="startAt = null"
              />
            </template>
          </b-datetimepicker>
        </b-field>

        <b-field label="配信タイトル">
          <b-input
            type="text"
            v-model="title"
            placeholder="配信タイトルを入力してください"
          ></b-input>
        </b-field>

        <b-field label="配信内容について">
          <b-input
            type="textarea"
            placeholder="配信内容について入力してください"
            v-model="aboutLive"
          ></b-input>
        </b-field>

        <h3 class="has-text-weight-bold mb-2">サムネイル登録</h3>
        <div class="thumbnail">
          <figure class="image thumbnail__image">
            <img :src="previewImageUrl" />
          </figure>
          <b-field label="">
            <b-upload @input="onFileChanged" drag-drop expanded>
              <div class="content has-text-centered preview__upload">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p>Drop your files here or click to upload</p>
              </div>
            </b-upload>
          </b-field>
        </div>
      </div>
    </div>
    <div class="mt-5 has-text-centered">
      <b-button class="button is-primary" @click.native="submitLiveSchedule"
        >登録する</b-button
      >
    </div>
  </div>
</template>

<script>
import * as liveServices from '@/services/liveServices';
import * as storageServices from '@/services/storageServices';

export default {
  name: 'LiveScheduleRegistration',
  data() {
    return {
      startAt: null,
      title: null,
      aboutLive: '',
      imageFile: null,
      previewImageUrl: null
    };
  },
  methods: {
    async submitLiveSchedule() {
      // validate input data exist or not
      // TODO: validate datetime
      if (!this.startAt || !this.aboutLive || !this.imageFile || !this.title) {
        console.error('Requirement is insufficient.');
        // TODO: pop up a modal
        return;
      }

      // upload thumbnail to storage
      const storagePath = `lives/${this.$store.state.auth.uid}/thumbnails/${this.imageFile.name}`;
      const thumbnailUrl = await storageServices.uploadPhoto(
        storagePath,
        this.imageFile
      );

      const liveDoc = {
        startAt: this.startAt,
        title: this.title,
        aboutLive: this.aboutLive,
        thumbnailUrl: thumbnailUrl
      };

      // add liveDoc to firestore
      const addLiveDocresult = await liveServices.createUpComingLive(liveDoc);
      if (!addLiveDocresult) return;

      // prompt to live schedule page
      this.$router.push('/live/schedule');
    },
    onFileChanged(inputFile) {
      this.imageFile = inputFile;
      this.previewImageUrl = URL.createObjectURL(inputFile);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-schedule-registration.scss';
</style>
